/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceLine
 */
export interface InvoiceLine {
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    object?: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceLine
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceLine
     */
    discountable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    type?: string;
}

/**
 * Check if a given object implements the InvoiceLine interface.
 */
export function instanceOfInvoiceLine(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvoiceLineFromJSON(json: any): InvoiceLine {
    return InvoiceLineFromJSONTyped(json, false);
}

export function InvoiceLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceLine {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'object': !exists(json, 'object') ? undefined : json['object'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'discountable': !exists(json, 'discountable') ? undefined : json['discountable'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function InvoiceLineToJSON(value?: InvoiceLine | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': value.object,
        'amount': value.amount,
        'currency': value.currency,
        'description': value.description,
        'discountable': value.discountable,
        'type': value.type,
    };
}

